import * as React from 'react';

import LoginLink from 'bundles/user-account/components/LoginLink';
import { getErrorMessages } from 'bundles/user-account/utils/errorMessageUtils';

import _t from 'i18n!nls/user-account';

export default function ErrorMessage({ errorCode, ...rest }: { errorCode: string; id?: string }) {
  const MESSAGES = getErrorMessages;

  // @ts-expect-error TS7016 TODO: MESSAGES[errorCode] needs to be typed
  const message = MESSAGES[errorCode] || MESSAGES.unknownError;

  return (
    <div role="alert" aria-live="polite" className="c-user-modal-help-text m-b-1 color-danger" {...rest}>
      {message}
      {message === MESSAGES.existingCourseraAccount && (
        <span>
          &nbsp;
          <LoginLink>{_t('Please log in with the email address connected to your Coursera account')}</LoginLink>
        </span>
      )}
    </div>
  );
}
